let _ = require('../_.js');
var $ = jQuery;


// General purpose user interface effects not specific to business logic.


/** 
 * Creates selector method .click_pleasewait(callback), which behaves like click,
 * except it adds class async-pleasewait to the button while it is running, and prevents 
 * clicking on the button until the callback has resolved.
 */
$.fn.click_pleasewait = function (fn) {
    let min_dur = 500;
    let that = this;

    this.on("click", async function (e) {
        e.preventDefault();

        let start = Date.now();

        // If element already has 'async-please-wait' class, do not proceed
        if ($(that).hasClass('async-pleasewait')) {
            return;
        }

        $(that).addClass('async-pleasewait');
        $(that).blur();

        try {
            await fn.bind(that)(e);
        } catch (error) {
            console.error(error);
        } finally {
            let now = Date.now();
            let dur_unwait = start + min_dur - now;
            if (dur_unwait < 0) {
                $(that).removeClass('async-pleasewait');
            } else {
                setTimeout(function () {
                    $(that).removeClass('async-pleasewait');
                }, dur_unwait);
            }
        }
    });
};

// Fiven a photoable record from the backend, generates a url to get an image of a particular size.
// Returns 3x the requested size in order to accomidate retina displays.
_.photo_to_url = function (photo, width = null, height = null) {
    if (!width) {
        return _.photo_url_prefix + '/storage/uploads/' + photo.name + "." + photo.extension;
    } else if (width && !height) {
        return _.photo_url_prefix + '/uploads/' + width + 'x' + '/' + photo.name + '.' + photo.extension;
    } else {
        return _.photo_url_prefix + '/uploads/' + width + 'x' + height + '/' + photo.name + '.' + photo.extension;
    }
}

// Fiven a photoable record from the backend, generates a url to get an image of a particular size.
// Returns 3x the requested size in order to accomidate retina displays.
_.photo_to_url_dynamic = function (photo, width = null, height = null) {
    let devicePixelRatio = window.devicePixelRatio;
    if (!devicePixelRatio || devicePixelRatio < 1) {
        devicePixelRatio = 1;
    }
    if (!width) {
        return _.photo_url_prefix + '/storage/uploads/' + photo.name + "." + photo.extension;
    } else if (width && !height) {
        return _.photo_url_prefix + '/uploads/' + Math.ceil(width * devicePixelRatio) + 'x' + '/' + photo.name + '.' + photo.extension;
    } else {
        return _.photo_url_prefix + '/uploads/' + Math.ceil(width * devicePixelRatio) + 'x' + Math.ceil(height * devicePixelRatio) + '/' + photo.name + '.' + photo.extension;
    }
}

_.photo_to_element = function (photo, $element) {
    let width = $element.width();
    let height = $element.height();
    let url = _.photo_to_url(photo, width, height);
    if ($element.attr('src') != url) {
        $element.attr('src', url);
    }
}

// Set a divimg 'image' element to the target photo
$.fn.divimg = function (url_or_photo) {
    // Define thumbnailable extensions and file type icons
    const thumbnailableExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'pdf', 'tiff', 'tif'];
    const fileIcons = {
        'xlsx': 'fa-file-excel',
        'xls': 'fa-file-excel',
        'doc': 'fa-file-word',
        'docx': 'fa-file-word',
        'ppt': 'fa-file-powerpoint',
        'pptx': 'fa-file-powerpoint',
        'zip': 'fa-file-zipper',
        'rar': 'fa-file-zipper',
        '7z': 'fa-file-zipper',
        'tar': 'fa-file-zipper',
        'gz': 'fa-file-zipper',
        'mp4': 'fa-file-video',
        'avi': 'fa-file-video',
        'mov': 'fa-file-video',
        'wmv': 'fa-file-video',
        'flv': 'fa-file-video',
        'mkv': 'fa-file-video',
        'mp3': 'fa-file-audio',
        'wav': 'fa-file-audio',
        'flac': 'fa-file-audio',
        'aac': 'fa-file-audio',
        'ogg': 'fa-file-audio',
        'wma': 'fa-file-audio',
        'txt': 'fa-file-alt',
        'rtf': 'fa-file-alt',
        'csv': 'fa-file-csv',
        'dwg': 'fa-file-alt',
        'dxf': 'fa-file-alt',
        'cad': 'fa-file-alt',
        'ai': 'fa-file-alt',
        'eps': 'fa-file-alt',
        'psd': 'fa-file-image',
        'indd': 'fa-file-alt',
        'sketch': 'fa-file-alt',
        'fig': 'fa-file-alt',
        'default': 'fa-file'
    };

    $(this).each(function () {
        let $that = $(this);
        $that.data('divimg-url-or-photo', url_or_photo);
        $that.data('divimg-fn', function () {
            let url_or_photo = $that.data('divimg-url-or-photo');
            let width = $that.width();
            let height = $that.height();

            if ($that.attr('data-size')) {
                let sizes = $that.attr('data-size').split('x');
                width = sizes[0];
                height = sizes[1];
                $that.css('width', width + "px");
                $that.css('height', height + "px");
            }

            if ($that.attr('data-size-ratio')) {
                $that.css("width", "100%");
                width = $that.width();
                height = width / parseFloat($that.attr('data-size-ratio'));
                $that.css('width', width + "px");
                $that.css('height', height + "px");
            }

            // Determine file extension
            let fileExtension = null;
            if (url_or_photo && url_or_photo.extension) {
                // Photo record with extension property
                fileExtension = url_or_photo.extension.toLowerCase();
            } else if ($that.attr('data-extension')) {
                // HTML element with data-extension attribute
                fileExtension = $that.attr('data-extension').toLowerCase();
            }

            // Check if this is a thumbnailable file type
            let isThumbnailable = !fileExtension || thumbnailableExtensions.includes(fileExtension);

            if (!isThumbnailable) {
                // Clear any existing content and background
                $that.empty().css('background-image', 'none');
                
                // Set file icon styling
                $that.css({
                    'background-color': '#e9ecef',
                    'display': 'flex',
                    'align-items': 'center',
                    'justify-content': 'center'
                });

                // Get appropriate icon
                let iconClass = fileIcons[fileExtension] || fileIcons.default;
                
                // Create and insert icon element
                let iconHtml = `<i class="fa-solid ${iconClass}" style="color: #777777; font-size: 26px;"></i>`;
                $that.html(iconHtml);
                
                $that.addClass('divimg');
                $that.data('divimg-image-set', true);
                return;
            }

            // Original thumbnailable image logic
            if (!url_or_photo) {
                if (!$that.hasClass('divimg')) {
                    $that.addClass('divimg');
                }
                url_or_photo = $that.attr('data-src');
                if (!url_or_photo) {
                    url_or_photo = "/img/placeholder_property.png";
                }
                
                // Clear any existing icon content before setting background
                $that.empty().css({
                    'background-color': '',
                    'display': '',
                    'align-items': '',
                    'justify-content': ''
                });
                
                let target_rule = 'url(' + url_or_photo + ')';
                if ($that.css('background-image') != target_rule) {
                    $that.css('background-image', target_rule);
                }
            } else {
                if (url_or_photo.name) {
                    url_or_photo = _.photo_to_url_dynamic(url_or_photo, width, height);
                }
                
                // Clear any existing icon content before setting background
                $that.empty().css({
                    'background-color': '',
                    'display': '',
                    'align-items': '',
                    'justify-content': ''
                });
                
                $that.addClass('divimg');
                $that.data('divimg-image-set', true);
                let target_rule = 'url(' + url_or_photo + ')';
                if ($that.css('background-image') != target_rule) {
                    $that.css('background-image', target_rule);
                }
            }
        });

        // Apply image immediatly
        $that.data('divimg-fn')();

        // Apply image again on resize
        if (!$that.data('divimg-refresh-observer')) {
            $that.data('divimg-refresh-observer', true);
            _.on_ui_update_always(null, $that.data('divimg-fn'));
        }
    });
};

// Easy class for fixed size cropped version of target source image
// <div class="divimg" data-size="120x80" data-src="/foo.jpg" />

_.on_ui_update_once('.divimg', function () {

    let sizes = null;

    if ($(this).attr('data-size')) {

        sizes = $(this).attr('data-size').split('x');

        $(this).css("width", sizes[0] + "px")
        $(this).css("height", sizes[1] + "px")
        $(this).attr('data-size', '');
    }

    if ($(this).attr('data-size-ratio')) {
        let width = $(this).width();
        let height = $(this).height();

        $(this).css("width", "100%");
        width = $(this).width();
        height = width / parseFloat($(this).attr('data-size-ratio'));
        $(this).css('width', width + "px");
        $(this).css('height', height + "px");
    }

    if ($(this).attr('data-src') && !$(this).data('divimg-image-set')) {
        $(this).divimg($(this).attr('data-src'));
    }
});

// Recalculate ratios on page resize for divimg
_.on_ui_resize(function () {
    $(".divimg").each(function () {
        if ($(this).attr('data-size-ratio')) {
            let width = $(this).width();
            let height = $(this).height();

            $(this).css("width", "100%");
            width = $(this).width();
            height = width / parseFloat($(this).attr('data-size-ratio'));
            $(this).css('width', width + "px");
            $(this).css('height', height + "px");
        }
    });
});

// css class data-confirm - show a modal prompt before following a clicked link

_.on_ui_update_once('a[data-confirm]:not(.link-request-via-ajax)', function () {
    $(this).click(async function (e) {
        e.preventDefault();
        let that = this;

        // Get the value of data-confirm attribute
        var message = $(this).attr('data-confirm');

        // Async function call
        async function asyncCall() {
            let result = await _.Modal.confirm(message);
            if (result === true) {
                document.location.href = $(that).attr('href');
            }
        }

        // Invoke the async function
        asyncCall();
    });
});

// If a hash link points to a tab on the admin crud, scroll to top on click.
_.on_ui_update_once('a', function () {
    let $a = $(this);
    $a.click(function (e) {
        let href = $a.attr('href');
        if (!href || !href.charAt) {
            return;
        }
        if (href == '#') {
            e.preventDefault();
            return;
        }
        if (href.charAt(0) === '#' && href.includes('#')) {
            // Check if the element exists and has a role of 'tabpanel'
            let targetId = href.slice(1);
            try {
                let $targetElement = $('#' + targetId);
                if ($targetElement.length && $targetElement.attr('role') === 'tabpanel') {
                    // Prevent native anchor scroll (Bootstrap smooth-scroll makes it animated)
                    e.preventDefault();
                    // Scroll to top instantly when switching tabs
                    window.scrollTo({ top: 0, behavior: 'instant' });
                }
            } catch (e) {
            }
            _._ui_resize_immediate();
        }
    });
});


// Links with class link-request-via-ajax get requested via ajax rather than page navigation
// Response can contain an array of actions.  Possible actions are: 
//      ['success', 'The success message'],
//      ['error', 'The error message'],
//      ['redirect', 'The destination URL']
// We assume that the project has _.flash_alert(bootstrap class, message) defined.
// Also works with attribute data-confirm if defined.
_.on_ui_update_once('a.link-request-via-ajax', function () {
    let $link = $(this);
    $link.click_pleasewait(async function () {

        // Get the value of data-confirm attribute
        var confirm_message = $link.attr('data-confirm');

        // Prompt to confirm link if set
        if (confirm_message) {
            if (!await _.Modal.confirm(confirm_message)) {
                return false;
            }
        }

        // Dispatch request and handle result
        try {
            let result = await _.ajax({
                url: $link.attr('href'),
                method: 'POST',
                data: JSON.stringify($link.get(0).attributes)
            });
            if (Array.isArray(result)) {
                for (let i in result) {
                    let item = result[i];
                    if (item[0] == 'success') {
                        _.flash_alert(item[1], 'success');
                    }
                    if (item[0] == 'error') {
                        _.flash_alert(item[1], 'danger');
                    }
                    if (item[0] == 'redirect') {
                        document.location.href = item[1];
                    }
                }
            }
        } catch (e) {
            console.error(e);
            _.flash_error(e);
        }
    });
});

// "currencyInput"
// Grouping this in a function just to deliniate related code
new function () {

    // Makes an inputbox formatted so it looks like currency, but still returns / sets as integer
    let _hasInitCurrencyInput = false;
    $.fn.currencyInput = function (show_symbol = true) {

        let $that = this;

        $that.data('ci_show_symbol', show_symbol);

        if (!_hasInitCurrencyInput) {

            _hasInitCurrencyInput = true;

            $.fn._CIOriginalVal = $.fn.val;
            $.fn.val = function (value) {
                if ($(this).data("_currencyInput")) {
                    // custom behavior
                    if (arguments.length === 0) {
                        // Getter
                        var raw = $(this)._CIOriginalVal();
                        if (raw == '') {
                            return '';
                        }
                        var number = parseInt(raw.replace(/[^0-9]/g, ''));
                        return number; // Remove non-digits and convert to number
                    } else {
                        // Setter
                        value = String(value).replace(/[^0-9]/g, '');
                        if (value != '') {
                            var formatted = parseInt(value).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
                            if (!$(this).data('ci_show_symbol')) {
                                formatted = formatted.replace("$", "");
                            }
                            return $(this)._CIOriginalVal(formatted);
                        }

                        return $(this)._CIOriginalVal(value);
                    }
                } else {
                    // default behavior
                    if (arguments.length === 0) {
                        // Getter
                        return $(this)._CIOriginalVal();
                    } else {
                        // Setter
                        return $(this)._CIOriginalVal(value);
                    }
                }
            };

        }

        if (this.data("_currencyInput")) {
            return;
        }

        this.data("_currencyInput", true);

        this.on('focus', function () {
            $(this).select();
        });

        this.on('input', function () {
            var cursorPos = this.selectionStart;
            var val = $(this)._CIOriginalVal();
            var lengthBefore = val.length;

            // By setting it with .val(), formatting is applied
            $(this).val(val);

            var lengthAfter = $(this)._CIOriginalVal().length;

            if (lengthAfter > lengthBefore) {
                cursorPos += (lengthAfter - lengthBefore);
            } else if (lengthAfter < lengthBefore) {
                cursorPos -= (lengthBefore - lengthAfter);
            }

            this.setSelectionRange(cursorPos, cursorPos);

            // Clear the input when backspace is pressed and there's only one digit left
            if (this.value.replace(/[^0-9]/g, '').length === 1 && event.key === "Backspace") {
                $(this)._CIOriginalVal('');
            }
        });

        // Revert on submit
        $(document).on('submit', 'form', function (e) {
            $that._CIOriginalVal($that.val());
        });

        // Initialize first time
        $(this).val($(this)._CIOriginalVal());

        return this;
    };

    _.on_ui_update_once('.input-group-currency', function () {
        $(this).find('input').currencyInput(false);
    });

    // on jquery .submit() also revert the value
    $.fn._CIoriginalSubmit = $.fn.submit;
    $.fn.submit = function () {
        if (this.is('form')) { // Ensure this method is only applied on form elements
            this.find('input').each(function () {
                if ($(this).data("_currencyInput")) {
                    $(this)._CIOriginalVal($(this).val());
                }
            });
        }
        return $.fn._CIoriginalSubmit.apply(this, arguments);
    };

}();

// "phoneInput"
// Makes an input box formatted so it looks like a phone number (NNN) NNN-NNNN, but still returns / sets as number
let _hasInitPhoneInput = false;
$.fn.phoneInput = function () {

    let $that = this;

    if (!_hasInitPhoneInput) {

        _hasInitPhoneInput = true;

        $.fn._PIOriginalVal = $.fn.val;
        $.fn.val = function (value) {
            if ($(this).data("_phoneInput")) {
                // custom behavior
                if (arguments.length === 0) {
                    // Getter
                    var raw = $(this)._PIOriginalVal();
                    if (raw == '') {
                        return '';
                    }
                    var number = raw.replace(/[^0-9]/g, '');
                    return number; // Remove non-digits and convert to number
                } else {
                    // Setter
                    value = String(value).replace(/[^0-9]/g, '');
                    if (value.length === 11 && value.substr(0, 1) == "1") {
                        value = value.substr(1);
                    }
                    if (value.length === 10) {
                        var formatted = "(" + value.substr(0, 3) + ") " + value.substr(3, 3) + "-" + value.substr(6);
                        console.log(formatted);
                        return $(this)._PIOriginalVal(formatted);
                    }
                    return $(this)._PIOriginalVal(value);
                }
            } else {
                // default behavior
                if (arguments.length === 0) {
                    // Getter
                    return $(this)._PIOriginalVal();
                } else {
                    // Setter
                    return $(this)._PIOriginalVal(value);
                }
            }
        };

    }

    if (this.data("_phoneInput")) {
        return;
    }

    this.data("_phoneInput", true);

    this.on('input', function () {
        var raw = $(this)._PIOriginalVal();
        var number = raw.replace(/[^0-9]/g, '');

        // Allow only numbers, space, dash, and parentheses
        var cleaned = raw.replace(/[^0-9\s\-()]/g, '');
        $(this)._PIOriginalVal(cleaned);

        if (number.length === 11 && number.substr(0, 1) == "1") {
            $(this).val(number.substr(1));  // trigger setter
        }

        if (number.length === 10) {
            $(this).val(number);  // trigger setter
        }
    });

    // Revert on submit
    $(document).on('submit', 'form', function (e) {
        $that._PIOriginalVal($that.val());
    });

    // Initialize first time
    $(this).val($(this)._PIOriginalVal());

    return this;
};


// Initialize the phone input when the UI updates
_.on_ui_update_once('.input-group-phone', function () {
    $(this).find('input').phoneInput();
});

// on jquery .submit() also revert the value
$.fn._PIoriginalSubmit = $.fn.submit;
$.fn.submit = function (cb) {
    if (!cb) {
        if (this.is('form')) { // Ensure this method is only applied on form elements
            this.find('input').each(function () {
                if ($(this).data("_phoneInput")) {
                    $(this)._PIOriginalVal($(this).val());
                }
            });
        }
    }
    return $.fn._PIoriginalSubmit.apply(this, arguments);
};



/* Adds support for btn-hover-(class), applying btn-(class) to button, and replacing existing color, on hover, programatically. */
_.on_ui_update_once('.btn-hover', function () {
    $(this).hover(function () {
        var $this = $(this);
        if (!$this.data('btn-class')) {
            var currentCls = $this.attr('class').match(/btn-(primary|secondary|success|danger|warning|info|light|dark)/);
            if (currentCls) {
                $this.data('btn-class', currentCls[0]);
            }
        }
        var hoverCls = $this.attr('class').match(/btn-hover-(\w+)/)[1];
        $this.removeClass($this.data('btn-class')).addClass('btn-' + hoverCls);
    }, function () {
        var $this = $(this);
        var originalCls = $this.data('btn-class');
        if (originalCls) {
            var currentCls = $this.attr('class').match(/btn-(primary|secondary|success|danger|warning|info|light|dark)/)[0];
            if (currentCls != originalCls) {
                $this.removeClass(currentCls).addClass(originalCls);
            }
        }
    });

});

// Format a number as dollars and set it as text on an element
$.fn.currency = function (num) {
    this.text(_.currency(num));
};

// Function: Displays a clock in the format "H:mm:ss AM/PM" that starts from the given date and updates every second.
$.fn.clockFrom = function (date, suffix = null, two_line = false) {
    if (suffix === null) { suffix = ''; } else { suffix = ' ' + suffix; }
    let localizedTime = new Date(date).getTime();
    let startTime = new Date().getTime();
    setInterval(() => {
        const currentTime = new Date().getTime(); // Get current time in milliseconds
        const diffInSeconds = Math.floor((currentTime - startTime) / 1000); // Calculate time difference in seconds
        const time = new Date(localizedTime + diffInSeconds * 1000); // Add the time difference to initial timestamp
        const formattedTime = time.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit' }); // Format time as "H:mm:ss AM/PM"
        if (two_line) { // Update the content of the selected element with the formatted time
            this.oHtml(formattedTime.replace(' ', '<br />') + suffix);
        } else {
            this.oHtml(formattedTime + suffix);
        }
    }, 1000);
};

// Sets all elements with class placeholder-hover to only show placeholder text if the element is being hovered.
_.on_ui_update_once(".placeholder-hover", function () {
    const originalPlaceholder = $(this).attr('data-placeholder-hover');
    $(this).attr('placeholder', '');

    $(this).hover(
        () => $(this).attr('placeholder', originalPlaceholder),
        () => $(this).attr('placeholder', '')
    );
});

_.on_ui_update_once('.click_copy_to_clipboard', function () {
    $(this).click(function () {
        navigator.clipboard.writeText(this.value);
        _.flash_alert('Copied to Clipboard', 'success');
    });
});

_.on_ui_update_once('.click_input_value_open_in_new_window', function () {
    $(this).click(function () {
        window.open(this.value, '_blank');
    });
});

// "percentageInput"
// Grouping this in a function just to deliniate related code
new function () {

    $.fn.percentageInput = function () {
        this.addClass('percentage-input');
        this.val(this.val() + (this.val().indexOf('%') === -1 ? '%' : ''));
        this.on('input', function (e) {
            let value = e.target.value;
            let position = e.target.selectionStart;

            if (value.includes('%')) {
                // Ensure '%' is always at the end and update the value without additional '%'
                value = value.replace(/%/g, '') + '%';
            }

            // Move any input before '%'
            if (position >= value.length - 1) {
                let charBeforePercent = value.charAt(position - 1);
                value = value.slice(0, position - 1) + value.slice(position);
                position = Math.max(position - 1, 0);
                value = value.slice(0, position) + charBeforePercent + value.slice(position);
            }

            e.target.value = value;

            // Adjust the cursor position
            e.target.setSelectionRange(position, position);

            // Handle specific formatting cases
            let int = value.slice(0, -1);
            if (int === '100') {
                e.target.value = int + '%';
                e.target.setSelectionRange(3, 3);
            } else if (int.length >= 3 && int.length <= 4 && !int.includes('.')) {
                e.target.value = int.slice(0, 2) + '.' + int.slice(2) + '%';
                e.target.setSelectionRange(4, 4);
            } else if (int.length >= 5 && int.length <= 6) {
                let whole = int.slice(0, 2);
                let fraction = int.slice(2, 4);
                e.target.value = whole + '.' + fraction + '%';
            } else {
                e.target.value = int + '%';
                e.target.setSelectionRange(e.target.value.length - 1, e.target.value.length - 1);
            }
        });
        return this; // Allow chaining
    };

    // Overwite .val to work with .percentageInput.  Returns a simple number on response
    var originalVal = $.fn.val;
    $.fn.val = function (value) {
        if (typeof value === 'undefined' || isNaN(value)) {
            if (this.hasClass('percentage-input')) {
                let currentValue = originalVal.call(this);
                return currentValue.replace('%', '');
            }
            return originalVal.apply(this, arguments);
        } else {
            if (typeof (value) != 'string') {
                value = value + "";
            }
            if (this.hasClass('percentage-input')) {
                if (value !== '' && !value.includes('%')) {
                    value = parseFloat(value) + '%'; // Ensure two decimal places
                }
                return originalVal.call(this, value);
            }
            return originalVal.apply(this, arguments);
        }
    };

    _.on_ui_update_once('.percentage-input', function () {
        $(this).percentageInput();
    });

    // Todo: document me
    $.fn.droppable = function () {
        this.hide(); // Hide the original file input
        // let currentUploadRequest = null;

        // Unbind existing drag and drop events to prevent multiple bindings
        $('body').off('dragover.droppable drop.droppable');

        this.droppable_reset();

        let _handle_file_upload = async function (file, $input) {
            const maxFileSize = 20 * 1024 * 1024; // 20 MB in bytes

            if (file.size > maxFileSize) {
                alert('File size must not exceed 20 MB.');
                $input.droppable_reset();
                return;
            }

            let uid = _.uniqueId();

            $input.data('has-file', true);
            $input.data('file-uid', uid);
            $input.data('file-name', $input[0].files[0] ? $input[0].files[0].name : '');
            $input.data('upload-response', false);

            let error_id = $input.attr('data-error_description_id');
            if (error_id) {
                $("#" + error_id).text('').hide();
            }

            const formData = new FormData();
            formData.append('file', file);

            // Append URL prefix if exists
            try {
                // Todo: we don't have a clean way to actually terminate previous upload if a new upload is started...
                let response = await _.ajax({
                    url: $input.attr('data-endpoint'),
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    beforeSend: function (xhr) {
                        if (_.AuctionUI_Session && _.AuctionUI_Session.get_token_cookie) {
                            xhr.setRequestHeader('Authorization', 'Bearer ' + _.AuctionUI_Session.get_token_cookie());
                        }
                    }
                });

                // Did the uid change?  this indicates we aborted a previous upload.
                let current_uid = $input.data('file-uid');
                if (current_uid == uid) {
                    console.log("File upload complete, server said", response);
                    $input.data('upload-response', response);
                }
            } catch (e) {
                console.error(e);
                $input.data('has-file', false);
                $input.data('upload-response', false);

                let error_str = "There was an issue uploading this file, please try again.";

                if (typeof (e) == "string") {
                    error_str = e;
                }

                if ($("#" + error_id).length) {
                    $("#" + error_id).hide().text(error_str).fadeIn();
                } else {
                    alert(error_str);
                }

                $input.droppable_reset();
                return;
            }
        };

        // Add a custom file upload area
        this.each(function () {
            var $input = $(this);
            var $uploadContainer = $input.next('.droppable-upload-area');
            var $uploadArea, $infoContainer, $fileInfo, $removeButton;

            if ($uploadContainer.length === 0) {
                // Create elements if they do not exist
                $uploadContainer = $('<div class="droppable-upload-area"></div>');
                $uploadArea = $('<div class="droppable-upload-area-label">Click or drop a file to upload here</div>');
                $infoContainer = $('<div class="droppable-file-info-container"></div>');
                $fileInfo = $('<div class="droppable-file-info"></div>');
                $removeButton = $('<button type="button" class="droppable-remove-file btn btn-xs btn-secondary"><i class="fa-solid fa-xmark"></i>&nbsp;Remove</button>');

                $uploadContainer.data('input-ref', $input);
                $input.data('input-uploadArea', $uploadArea);
                $input.data('input-infoContainer', $infoContainer);
                $input.data('input-fileInfo', $fileInfo);
                $input.data('input-removeButton', $removeButton);

                $uploadContainer.insertAfter($input);
                $uploadArea.appendTo($uploadContainer);
                $infoContainer.appendTo($uploadContainer).hide();
                $fileInfo.appendTo($infoContainer);
                $removeButton.appendTo($infoContainer);
            } else {
                // Reset existing elements
                $uploadArea = $uploadContainer.find('.droppable-upload-area-label');
                $infoContainer = $uploadContainer.find('.droppable-file-info-container');
                $fileInfo = $uploadContainer.find('.droppable-file-info');
                $removeButton = $uploadContainer.find('.droppable-remove-file');

                // Reset the state
                $input.val('');
                $infoContainer.hide();
                $uploadArea.show();
            }

            // Trigger file input when upload area is clicked
            $uploadArea.click(function () {
                $input.trigger('click');
            });

            // Update UI when a file is selected
            $input.on('change', function () {
                var filename = $input[0].files[0] ? $input[0].files[0].name : '';
                if (filename) {
                    $fileInfo.text(filename).show();
                    $infoContainer.show();
                    $uploadArea.hide();
                } else {
                    $fileInfo.text('').hide();
                    $infoContainer.hide();
                    $uploadArea.show();
                }
                var file = $input[0].files[0];
                if (file) {
                    _handle_file_upload(file, $input);
                }
            });

            // Remove file functionality
            $removeButton.click(function () {
                $input.droppable_reset();
            });
        });

        // Handle drag and drop
        $('body').on('dragover.droppable', function (e) {
            e.preventDefault();
            e.stopPropagation();
        }).on('drop.droppable', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var files = e.originalEvent.dataTransfer.files;
            if (files.length > 0) {
                var file = files[0];
                var $dropTarget = $(e.target).closest('.droppable-upload-area');
                var fileInput = $dropTarget.data('input-ref');
                if (fileInput && fileInput.length > 0 && $dropTarget.is(':visible')) {
                    fileInput[0].files = files;
                    fileInput.trigger('change');
                    _handle_file_upload(file, fileInput);
                }
            }
        });

        return this;
    };

    $.fn.droppable_reset = function () {
        let $input = this;
        // if (currentUploadRequest) {
        //     currentUploadRequest.abort();
        // }
        $input.data('upload-response', false);
        $input.data('has-file', false);
        $input.data('file-uid', null);
        $input.val('');
        $input.data('input-fileInfo') && $input.data('input-fileInfo').text('').hide();
        $input.data('input-infoContainer') && $input.data('input-infoContainer').hide();
        $input.data('input-uploadArea') && $input.data('input-uploadArea').show();
    }

    // Returns true if the user has picked a file for upload.
    $.fn.droppable_file_is_dropped = function () {
        return this.data('has-file') == true;
    }

    // Returns true if a pending file upload is in progress
    $.fn.droppable_file_is_uploading = function () {
        if (!this.data('has-file')) {
            return false;
        }

        if (this.data('upload-response')) {
            return false;
        }

        return true;
    };

    // Returns true if the user has picked a file for upload.
    $.fn.droppable_get_filename = function () {
        return this.data('file-name');
    }

    // Returns a promise which resolves to the response a server gives after a file upload
    $.fn.droppable_upload_get_response = function () {
        var $input = this;
        return new Promise((resolve) => {
            var checkResponse = function () {
                if (!$input.data('has-file')) {
                    return false;
                }
                if ($input.data('upload-response')) {
                    resolve($input.data('upload-response'));
                } else {
                    setTimeout(checkResponse, 200); // Check every 200 ms
                }
            };
            checkResponse();
        });
    };



}();

// Pass a class name and a title, and elements which have this class will have this title applied automatically
_.register_dynamic_title_by_class = function (class_name, title) {
    let elements_applied = [];

    _.on_ui_update_always('.' + class_name, function () {
        if ($(this).attr('title') != title) {
            $(this).attr('title', title);
            elements_applied.push($(this));
        }
    });

    _.on_ui_update_always(null, function () {
        for (let i = 0; i < elements_applied.length; i++) {
            if (!elements_applied[i].hasClass(class_name) && elements_applied[i].attr('title') == title) {
                elements_applied[i].attr('title', '');
                elements_applied.splice(i, 1); // Remove the element at index i
                i--; // Decrement i by 1 to adjust the loop counter
            }
        }
    });
}




